import axios from 'axios'
import * as accessTokenInfo from "../../accessToken";

export const postBudgetReuqest = ({commit}, payload) => {
      
    axios.post('/budget/process/index.php', payload)
    .then(res => { 
        commit('unsetOverlayState')
        console.log(JSON.stringify(res.data))

    })
    .catch(error => {
        console.log(error)
        commit('setAlertBox', {title: 'message.error', message: 'Error: Please try again!!'})                
    })

}

export const fetchEventTypes = ({commit}) => {

    axios.get('/budget/eventTypes/index.php')
    .then(res => { 
        commit('unsetOverlayState')
        commit('setEventTypeList', res.data.response)            
    })
    .catch(error => {
        console.log(error)
        commit('setAlertBox', {title: 'message.error', message: 'Error: Please try again!!'})                
    })

}

export const fetchFinancialConfiguration = ({commit}) => {

    axios.get('/budget/financialConfiguration/index.php')
    .then(res => { 
        commit('unsetOverlayState')
        commit('setFinancialConfig', res.data.response)            
    })
    .catch(error => {
        console.log(error)
        commit('setAlertBox', {title: 'message.error', message: 'Error: Please try again!!'})                
    })

}


// WEBPACK FOOTER //
// ./src/store/modules/budget/actions.js